export default __webpack_public_path__ + "static/media/Proxima-Nova-Bold.d18f36dc.ttf";